import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Script from 'next/script';
import React from 'react';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import Product from '@models/product';

const { locally } = publicRuntimeConfig;

interface Props {
  className?: string;
  product: Product;
}
const LocallyDropdown = ({ className, product }: Props) => {
  const { geo } = useCurrentUrl();
  const { t } = useTranslation();
  const lang = geo?.locale.toLowerCase();

  // Check if component should render based on product conditions
  const shouldRender =
    product?.shop?.upc &&
    !product.shop.disableLocally &&
    product.shop.ctaButtonType !== 'shopLocal';

  const config = React.useMemo(
    () => ({
      company_name: locally?.companyName,
      button_text: t('productDetailPageContent.locallyButtonText', undefined, {
        default: 'Shop Local',
      }),
      button_id: 'HTML',
      company_id: String(locally?.companyId),
      css: '5',
      button_toggles_all: '1',
      upc: product.shop.upc ?? '',
      show_location_switcher: '1',
      show_location_prompt: '1',
      lang: lang || 'en-US',
      show_dealers: '1',
      n_dealers: '3',
      show_dealer_count: '1',
      show_address: '1',
      show_phone: '1',
      link_opens_modal: '1',
    }),
    [t, product.shop.upc, lang],
  );

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={`locally-dropdown-style ${className || ''}`}>
      <div
        id="lcly-button-0"
        data-switchlive="true"
        data-switchlive-impression="true"
        data-switchlive-impression-id-PL="1"
        className={`locally-dropdown-style ${className || ''}`}
      >
        <a
          id="lcly-link-0"
          data-switchlive="true"
          data-switchlive-mode="auto"
          data-switchlive-id-PL="6"
          role="button"
          href="https://join.locally.com/for-brands"
          target="_blank"
        >
          Product Locator by Locally
        </a>
        <Script
          id="lcly-script"
          src={`https://traeger-grill.locally.com/stores/map.js?${new URLSearchParams(config)}`}
        />
      </div>
    </div>
  );
};

export default LocallyDropdown;
